import { defineMessages } from 'react-intl';

export const i18n: {
	dateFilterTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterFromTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterFromLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterToTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterToLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterDateInputPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterAnyTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterToday: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterYesterday: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterLastWeek: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterLastMonth: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterLastYear: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterCustom: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterCustomInvalidDateAfterToday: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterCustomInvalidToDateAfterToday: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterCustomInvalidDateAfterEnd: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterToRange: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterUpdateButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterBeforeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateFilterAfterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dateFilterTitle: {
		id: 'date.filter.title',
		defaultMessage: 'Last updated',
		description: 'Filter by the date content was modified',
	},
	dateFilterFromTitle: {
		id: 'date.filter.from.title',
		defaultMessage: 'From',
		description: 'Filter starting from a custom date',
	},
	dateFilterFromLabel: {
		id: 'date.filter.from.label',
		defaultMessage: 'Choose start date to filter',
		description: 'Filter starting from a custom date',
	},
	dateFilterToTitle: {
		id: 'date.filter.to.title',
		defaultMessage: 'To',
		description: 'Filter up to a custom date',
	},
	dateFilterToLabel: {
		id: 'date.filter.to.label',
		defaultMessage: 'Choose end date to filter',
		description: 'Filter starting to a custom date',
	},
	dateFilterDateInputPlaceholder: {
		id: 'date.filter.input.placeholder',
		defaultMessage: 'Choose a date',
		description: 'Placeholder text for date input',
	},
	dateFilterAnyTime: {
		id: 'date.filter.any.time',
		defaultMessage: 'Anytime',
		description: 'Option to show content from any time',
	},
	dateFilterToday: {
		id: 'date.filter.today',
		defaultMessage: 'Today',
		description: 'Date range of content modified today',
	},
	dateFilterYesterday: {
		id: 'date.filter.yesterday',
		defaultMessage: 'Yesterday',
		description: 'Date range of content modified yesterday',
	},
	dateFilterLastWeek: {
		id: 'date.filter.last.week',
		defaultMessage: 'Past 7 days',
		description: 'Date range of content modified in the last 7 days',
	},
	dateFilterLastMonth: {
		id: 'date.filter.last.month',
		defaultMessage: 'Past 30 days',
		description: 'Date range of content modified in the last 30 days',
	},
	dateFilterLastYear: {
		id: 'date.filter.last.year',
		defaultMessage: 'Past year',
		description: 'Date range of content modified in the last 365 days',
	},
	dateFilterCustom: {
		id: 'date.filter.custom',
		defaultMessage: 'Custom',
		description: 'Custom date range',
	},
	dateFilterCustomInvalidDateAfterToday: {
		id: 'date.filter.custom.invalid.after.today',
		defaultMessage: 'The From date can’t be in the future',
		description: 'error displayed when a date range begins after the current date',
	},
	dateFilterCustomInvalidToDateAfterToday: {
		id: 'date.filter.custom.invalid.to.after.today',
		defaultMessage: 'The To date can’t be in the future',
		description: 'error displayed when a date range ends after the current date',
	},
	dateFilterCustomInvalidDateAfterEnd: {
		id: 'date.filter.custom.invalid.after.end',
		defaultMessage: 'The From date has to be before the To date',
		description: 'error displayed when a date range begins after the end date',
	},
	dateFilterToRange: {
		id: 'date.filter.to.range',
		defaultMessage: 'to',
		description: "'to' in between from and to date pickers",
	},
	dateFilterUpdateButton: {
		id: 'date.filter.update.button',
		defaultMessage: 'Update',
		description: 'Text for update button in date filter picker',
	},
	dateFilterBeforeLabel: {
		id: 'date.filter.before.label',
		defaultMessage: 'before',
		description:
			'Drop-down option label in the date filter picker indicating results modified before a selected date.',
	},
	dateFilterAfterLabel: {
		id: 'date.filter.after.label',
		defaultMessage: 'after',
		description:
			'Drop-down option label in the date filter picker indicating results modified after a selected date.',
	},
});
